module.exports = __webpack_public_path__ + "media/images/logos/square-logo-e595692b7b7c736d0d02c05a42efacdf.gif";